import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ProductsModule } from '@mkp/product/feature-product-listing';
import { Button, ButtonColor, ButtonComponent, ButtonSize } from '@mkp/shared/ui-library';
import { DataTestDirective } from '@mkp/tracking/feature-tracking';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mkp-demo-products',
  imports: [ButtonComponent, RouterLink, TranslateModule, DataTestDirective, ProductsModule],
  templateUrl: './demo-products.component.html',
  styleUrl: './demo-products.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoProductsComponent {
  @Input() showPlatformSwitch = true;
  @Input() showStickyHeader = false;

  readonly registerBtnConfig: Button = {
    color: ButtonColor.Primary,
    size: ButtonSize.Medium,
    fullWidth: true,
  };
}
